import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, ZoomInIcon } from 'lucide-react';
import { insidePages } from '../data/salesContent';
export function InsidePreviewSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const openPage = openIndex !== null ? insidePages[openIndex] : null;
  useEffect(() => {
    if (openIndex === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpenIndex(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [openIndex]);
  return <section className="bg-white py-16 lg:py-24" data-id="element-80" data-mp="f9bceb5liurz">
      <div className="mx-auto max-w-6xl px-5" data-id="element-81" data-mp="k4z3wx7jw00n">
        <div className="mx-auto max-w-2xl text-center" data-id="element-82" data-mp="k7v0ah3r2gmz">
          <h2 className="font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-83" data-mp="2zwejoojes12g">
            See How the Guide Works
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink" data-id="element-84" data-mp="32jtf4xhxpz4u">
            Clear diagrams. Practical explanations. Checklists you can actually use.
          </p>
        </div>

        <ul className="mt-12 grid grid-cols-2 gap-5 lg:grid-cols-4 lg:gap-6" data-id="element-85" data-mp="2ykaum2u0zq2j">
          {insidePages.map((page, i) => <li key={page.title} className="flex flex-col" data-id="element-86" data-mp="37iwatrc0yt05" data-mpi={i}>
              <button type="button" onClick={() => setOpenIndex(i)} className="group relative overflow-hidden rounded-xl border border-line bg-mist focus:outline-none focus-visible:ring-4 focus-visible:ring-aqua/40" aria-label={`Enlarge: ${page.title}`} data-id="element-87" data-mp="37hbgo2tmhc2t">
                <img src={page.src} alt={page.title} className="aspect-[3/4] w-full object-cover object-top transition-transform duration-200 ease-out group-hover:scale-[1.02]" data-id="element-88" data-mp="3q9dyhhi02yen" />
                <span className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy shadow-md" data-id="element-89" data-mp="43h0sq3ncjf0">
                  <ZoomInIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="b3jbi7i4tlry" />
                </span>
              </button>
              <h3 className="mt-4 font-display text-base font-bold text-navy sm:text-lg" data-id="element-91" data-mp="l3tllj8ved2w">
                {page.title}
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-ink" data-id="element-92" data-mp="pv1vshi0y2h4">{page.caption}</p>
            </li>)}
        </ul>
      </div>

      <AnimatePresence data-id="element-93" data-mp="uvplmzuiod9r">
        {openPage && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-navy/80 p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={() => setOpenIndex(null)} role="dialog" aria-modal="true" aria-label={openPage.title} data-id="element-94" data-mp="ytx3xz4mpmn2">
            <motion.img src={openPage.src} alt={openPage.title} className="max-h-[88vh] w-auto rounded-xl bg-white" initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.96
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} onClick={e => e.stopPropagation()} data-id="element-95" data-mp="3amc5ymcv9b8q" />
            <button type="button" onClick={() => setOpenIndex(null)} className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-white text-navy focus:outline-none focus-visible:ring-4 focus-visible:ring-aqua/50" aria-label="Close preview" data-id="element-96" data-mp="3m043wkldzoqs">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-97" data-mp="374o4s15y92nj" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </section>;
}